@if (isInGrid() || field == null || field.ViewDataSourcesID == null || field.ViewDataSourcesID <= 0 ||
    (field.ViewDataSourcesID>= 0 && !isInGrid() && !field.IsReadOnly && !isLocked())) {
    @if (isInGrid() && instance()) {
    @if (gridFileName(); as fileName) {
    @if (fileName.split('.').pop(); as ext) {
    <div class="flex w-full cursor-pointer items-center justify-center gap-4 text-blue-500 hover:text-blue-700"
        (click)="downloadFromGrid()">
        <bizz-extension-icon [extension]="ext" [size]="'extraSmall'" class="flex items-center">
        </bizz-extension-icon>
        <span
            class="text-small line-break-anywhere w-full max-w-[calc(100%_-_40px)] text-wrap break-words font-semibold">{{
            fileName
            }}</span>

    </div>
    }
    }
    }

    <bizz-file-select-multi [id]="'fileUpload_'+fileUid"
        (filesSelected)="filesDropped($event)"></bizz-file-select-multi>
    @if (((field?.IsReadOnly || isLocked()) && !isInGrid())) {
    @if (!uploading && !validatingFile && currentFile(); as currentFile) {
    <div class="flex h-auto max-w-full flex-col flex-wrap items-center justify-between gap-4 text-wrap break-words rounded-t bg-button p-3 sm:flex-row xl:flex-nowrap"
        [class.justify-center]="filePreview == null || !previewEnabled">
        <div class="flex w-full flex-grow items-center gap-4"
            (click)="(field != null && field.ViewDataSourcesID > 0 && !isInGrid()) ? downloadFromDataSource(): download()"
            [class.select-none]="!canDownload()" [class.text-blue-500]="canDownload()"
            [class.cursor-pointer]="canDownload()" [class.hover:text-blue-700]="canDownload()">
            @if (currentFile.split('.').pop(); as ext) {
            <bizz-extension-icon [extension]="ext" [size]="'extraSmall'"
                class="flex items-center">
            </bizz-extension-icon>
            <span
                class="text-small line-break-anywhere max-w-[calc(100%_-_40px)] text-wrap break-words font-semibold">{{
                currentFile
                }}</span>
            }
        </div>

        @if (field != undefined && (field.ViewDataSourcesID == undefined || field.ViewDataSourcesID <= 0) &&
            !this.isInGrid() && (this.pwaService.isPwa() ? this.pwaService.isOnline() : true)) { <div
            class="flex w-full flex-col gap-3 xl:hidden">
    </div>

    @if (!!documentProperties()?.DocumentComparison?.InstanceCanBeCompared && filePreview != null &&
    previewEnabled && filePreview!.DisplayType == FilePreviewDisplayType.PDF) {
    <div class="hidden flex-shrink-0 items-center xl:flex">
        <!--<bizz-icon class="h-5 w-5 text-blue-500" iconName="file-lines"></bizz-icon>-->
        <div class="button-group" #compareAnchor>
            @if (compareFile == undefined) {
            <bizz-loader-button buttonClass="button default text-xs" [isLoading]="loadingCompare"
                (click)="compare(-1, versionsId)" icon="code-compare" [disabled]="loadingCompare">{{
                "ShowComparison" |
                translate
                }}
            </bizz-loader-button>
            } @else {
            <bizz-loader-button buttonClass="button default text-xs" [isLoading]="loadingCompare"
                (click)="clearCompareFile()" icon="file-lines" [disabled]="loadingCompare">
                {{ "ShowCurrentVersion" | translate }}
            </bizz-loader-button>
            }
            @if(documentProperties()?.DocumentComparison?.InstanceArchiveCanBeCompared){
                <button class="form-header-button default" type="button" (click)="toggleComparePopup($event)"
                    [disabled]="loadingCompare || compareFile != undefined">
                    <bizz-toggle-arrow class="h-4 w-4" [direction]="showComparePopup ? 'up' : 'down'" />
                </button>
            }
        </div>
        @if (showComparePopup) {
        <kendo-popup #comparePopup class="z-[1004]" [margin]="{ horizontal: 0, vertical: 5 }"
            (anchorViewportLeave)="toggleComparePopup($event)" [anchor]="compareAnchor"
            [anchorAlign]="popupAnchorAlignCompare" [popupAlign]="popupAlign">
            <div class="bizz-popup-content text-nowrap p-2 box-border flex flex-col gap-1">
                <span class="text-xs grey-lighter px-2 py-1 uppercase leading-4">{{ 'CompareTo' | translate }}</span>
                <button (click)="compare(-1, versionsId)" class="text-sm flex gap-2 py-1 px-2 leading-4">
                    <bizz-icon class="h-[14px] w-[14px]" iconName="diagram-predecessor" />
                    {{ 'PreviousVersion' | translate }}
                </button>
                <button (click)="toggleCompareModal()" class="text-sm flex gap-2 py-1 px-2 leading-4">
                    <bizz-icon class="h-[14px] w-[14px]" iconName="clock-rotate-left" />
                    {{ 'OlderVersion' | translate }}
                </button>
            </div>
        </kendo-popup>
        }
    </div>
    }
    }

    </div>
    @if (compareFile != undefined) {
    @if (documentComparison(); as comparison) {
    <div
        class="flex h-auto max-w-full flex-col flex-wrap items-center justify-between gap-4 text-wrap break-words bg-button px-3 pb-3 sm:flex-row xl:flex-nowrap">
        <span class="hidden flex-col flex-shrink-0 flex-grow items-center gap-2 xl:flex xl:items-start">
            <p class="text-sm">{{ 'ComparedOn' | translate }}:
                <strong>{{ comparison.CompareDate | datetime }}</strong>
            </p>
            <p class="text-sm">{{ "ComparingWith" | translate }}:
                <strong>{{ comparison.SourceVersion }}</strong>
            </p>
        </span>
    </div>
    }
    }

    @if (filePreview != null && previewEnabled) {
    <!-- Preview -->
    @switch (filePreview!.DisplayType) {
    @case (FilePreviewDisplayType.Image) {
    <!-- Image -->
    <div
        class="mb-5 flex h-full w-full items-center justify-center rounded-b border-x-2 border-b-2 border-t-0 border-form-control bg-button p-1">
        <img [id]="'file_imagepreview_'+fileUid"
            [src]="'data:' + filePreview.ContentType + ';base64,' + filePreview.File" alt="" />
    </div>
    }
    @case (FilePreviewDisplayType.PDF) {
    <!-- PDF -->
    @if (toolPermissions(); as toolPermissions) {
    @if (showPdfViewer && canShowPdfViewer) {
    <div class="relative">
        <ngx-extended-pdf-viewer #pdfViewer (pdfLoadingStarts)="togglePdfLoader(true)"
            (pageRendered)="togglePdfLoader(false)" (pdfLoadingFailed)="togglePdfLoader(false)"
            [base64Src]="compareFile ?? filePreview!.File" [customToolbar]="customToolbar" [zoom]="zoomLevel"
            [textLayer]="true" [showFindButton]="true" [showSidebarButton]="false" [sidebarVisible]="false"
            [showDownloadButton]="toolPermissions.download ? 'always-visible' : false"
            [height]="viewerHeight < 600 ? '600px' : viewerHeight + 'px'">
        </ngx-extended-pdf-viewer>
        <ng-template #customToolbar>
            <div id="toolbarViewer" class="bizz-toolbar">
                <div id="toolbarViewerLeft" class="viewerLeft">
                    <pdf-find-button class="hidden" #findButton></pdf-find-button>
                    <button class="py-1" (click)="findButton.onClick();findToolActive=!findToolActive"
                        [class.bg-button-hover]="findToolActive">
                        <bizz-icon class="size-4" iconName="magnifying-glass"></bizz-icon>
                    </button>
                    <pdf-paging-area></pdf-paging-area>
                </div>
                <div class="toolbarViewerMiddle">
                    <pdf-zoom-toolbar></pdf-zoom-toolbar>
                </div>
                <div id="toolbarViewerRight" class="viewerRight">
                    @if (toolPermissions.selection) {
                    <pdf-select-tool #selectTool class="hidden"></pdf-select-tool>
                    <pdf-hand-tool #handTool class="hidden"></pdf-hand-tool>
                    <button class="toolbarButton" (click)="selectTool.onClick();handToolActive=false"
                        [class.bg-button-hover]="!handToolActive">
                        <bizz-icon class="size-4" iconName="i-cursor"></bizz-icon>
                    </button>
                    <button class="toolbarButton" (click)="handTool.onClick();handToolActive=true"
                        [class.bg-button-hover]="handToolActive">
                        <bizz-icon class="size-4" iconName="hand-pointer"></bizz-icon>
                    </button>
                    }
                    @if (toolPermissions.print) {
                    <pdf-print></pdf-print>
                    }
                    @if (toolPermissions.download) {
                    <button class="toolbarButton" (click)="downloadKendoPreviewFile($event)">
                        <bizz-icon class="size-4" iconName="download"></bizz-icon>
                    </button>
                    }
                </div>
            </div>
        </ng-template>
        @if (showPdfLoader) {
        <bizz-loader [showLoader]="true" class="absolute left-0 top-0 h-full w-full"></bizz-loader>
        }
    </div>
    }
    }
    }
    @case (FilePreviewDisplayType.Converting) {
    <!-- Converting -->
    <div
        class="flex flex-col items-center justify-center gap-2 rounded-b border-2 border-form-control bg-section pb-5 font-sans font-semibold text-default">
        <div class="relative flex size-14 h-full min-h-16 w-full items-center justify-center">
            <bizz-loader [showLoader]="true" backgroundClasses="bg-transparent"></bizz-loader>
        </div>
        <p>{{ "PreviewBusy" | translate }}</p>
        <button type="button" class="default" (click)="refreshFilePreview()" [tabIndex]="-1"
            [disabled]="refreshingPreview">{{ "Retry" | translate }}
        </button>
    </div>
    }
    @case (FilePreviewDisplayType.SizeWarning) {
    <!-- Size Warning -->
    <div
        class="flex flex-col items-center justify-center gap-2 rounded-b border-2 border-form-control bg-section py-4 font-sans font-semibold text-default">
        <bizz-icon class="h-14 w-14 text-yellow-300" iconName="file-circle-exclamation" [hover]="true">
        </bizz-icon>
        <p class="text-sm text-widget-button">{{ "LargePreview" | translate }}
            ({{ fileSizeLargePreview() | bytes }})</p>
        <button type="button" class="default" (click)="refreshFilePreview(true)" [tabIndex]="-1"
            [disabled]="refreshingPreview">{{ "ShowPreview" | translate }}
        </button>
    </div>
    }
    @case (FilePreviewDisplayType.Unsupported) {
    <!-- Unsupported -->
    <div
        class="flex flex-col items-center justify-center gap-2 rounded-b border-2 border-form-control bg-section py-4 font-sans font-semibold text-default">
        <bizz-icon class="h-14 w-14 text-lighter" iconName="file-circle-exclamation" [hover]="true">
        </bizz-icon>
        <p class="text-sm text-widget-button">{{ "FileNotPreviewable" | translate }}</p>
    </div>
    }
    }
    }
    } @else {
    <div class="flex flex-col items-center justify-center gap-5 rounded border-2 border-section bg-section py-4">
        <bizz-icon class="m-auto block w-14 p-2 text-widget-button md:ml-auto" iconName="file-circle-exclamation"
            [hover]="true">
        </bizz-icon>
        <p class="text-sm text-widget-button">{{ "NoFile" | translate }}</p>
    </div>
    }
    @if (currentFile() && showViewOnline()) {
    <div class="flex w-full flex-wrap justify-center gap-3.5 border-form-control bg-section px-4 pb-4 pt-2.5">
        <button type="button" class="button form text-xs" [tabIndex]="-1"
            (click)="openOnline(FileUploadEditOnlineModalComponentMode.View)">
            <bizz-icon class="ml-auto block size-3.5 text-blue-500 md:ml-0" iconName="eye" [hover]="true">
            </bizz-icon>
            {{ "DirectEdit_View" | translate }}
        </button>
    </div>
    }
    } @else {
    <!--<ng-container *ngIf="percentage == 0 && !uploaded && !uploadFailed && !uploadOverSize && !readonly">-->
    @if (!isInGrid() && (field == null || (!field.IsReadOnly && !isLocked())) || (isInGrid() && !instance())) {
    <div bizz-drag-drop [disabled]="isLocked() || disabled" (files)="filesDropped($event)"
        (isHoveringDragDrop)="isHoveringDragDrop = $event" class="flex h-auto flex-col rounded border-2 border-dashed"
        [class.min-h-52]="minified != true" [class.pt-4]="minified != true"
        [class.border-form-control]="!isHoveringDragDrop"
        [class.bg-section]="minified != true && !isHoveringDragDrop && !currentFile() && errors == null"
        [class.bg-form-control]="minified == true"
        [ngClass]="{'bg-red-500/20 border-red-500' : errors, 'bg-blue-500/20 border-blue-500' : isHoveringDragDrop}">
        @if (validatingFile && minified == false) {
        <div class="m-4 flex h-56 flex-col items-center justify-center gap-2 rounded sm:flex-row sm:gap-14">
            <!-- Circular progressbar     -->
            <kendo-circularprogressbar class="animate-spin" [value]="75" style="height: 8rem; width: 8rem">
            </kendo-circularprogressbar>
            <!-- Progress text     -->
            <div class="flex flex-col items-center font-bold">
                <p> {{ "ValidatingFile" | translate }} </p>
            </div>
        </div>
        }
        @for (fileUpload of fileUploads; track $index) {
        @if (fileUpload.fileChunkUpload; as file) {
        <div class="m-4 flex flex-col items-center justify-center gap-2 rounded sm:flex-row sm:gap-14"
            [ngClass]="minified != true ? ['h-56'] : ['h-9']">
            <!-- Circular progressbar     -->
            @if (minified == false) {
            <kendo-circularprogressbar [value]="file.progress" style="height: 8rem; width: 8rem">
                <ng-template kendoCircularProgressbarCenterTemplate let-color="color" let-value="value">
                    <span [style.color]="color" class="text-lg font-bold">{{ value | number : '1.0-0' }}
                        <span [style.color]="color" class="text-xs">%</span></span>
                </ng-template>
            </kendo-circularprogressbar>
            }
            <!-- Progress text     -->
            <div class="flex flex-col items-center">
                @if (minified == false) {
                <p class="text-title text-sm">{{ file.fileName }}</p>
                }
                <!--TODO: How to translate this? -->
                <p class="text-widget-on-button mb-5 text-sm">
                    {{ file.progress | number : '1.0-0' }}%
                    {{ "of" | translate }} {{ file.size | bytes }}
                    {{ "Uploaded" | translate }}</p>
                @if (minified == false) {
                <button type="button" class="button cancel" [tabIndex]="-1" (click)="fileUpload.cancel()">{{
                    "Cancel" |
                    translate
                    }}
                </button>
                }
            </div>
        </div>
        }
        } @empty {
        @if (currentFile(); as currentFile) {
        <div class="flex h-auto flex-row items-center justify-center "
            [ngClass]="minified != true ? ['gap-4', 'px-4'] : ['sm:h-9']"
            [class.cursor-pointer]="minified != true && canDownload()"
            [class.text-blue-500]="minified != true && canDownload()"
            [class.hover:text-blue-700]="minified != true && canDownload()"
            (click)="(field != null && field.ViewDataSourcesID > 0 && !isInGrid()) ? downloadFromDataSource() : download()">
            <div class="m-auto max-w-full flex flex-wrap items-center justify-center text-wrap break-words text-center"
                [ngClass]="minified == true ? ['bg-button', 'rounded-sm', 'gap-1', 'w-5/6', 'py-1', 'px-[6px]'] : ['gap-4', 'w-full']">
                @if (currentFile.split('.').pop(); as ext) {
                <bizz-extension-icon class="float-right" [extension]="ext"
                    [size]="minified == true ? 'extraSmall' :'large'">
                </bizz-extension-icon>
                <span class="max-w-full text-wrap break-words font-semibold" [class.text-xs]="minified == true">{{
                    minified == true ?
                    (latestUploadFileName ?? currentFile | truncate: 14) :
                    (latestUploadFileName ??
                    currentFile)
                    }}</span>
                }
                @if (minified == true) {
                <bizz-icon [title]="'Delete' | translate" class="text-lighter size-4 cursor-pointer float-right ml-2"
                    (click)="emitFileChange(undefined)" [hover]="true" iconName="circle-xmark"></bizz-icon>
                }
            </div>

        </div>
        }
        @if (minified != true || currentFile() == undefined) {
        <div class="flex flex-1 flex-col items-center justify-center"
            [ngClass]="currentFile() || minified == true == null ? 'min-h-56' : ''" [class.sm:flex-row]="!errors">
            <!-- Dropzone-->
            @if (!forceStartFromTemplate()) {
            <div class="flex flex-1 items-center justify-center" [class]="minified != true? 'gap-4': 'gap-2'"
                [class.p-4]="minified != true" [class.flex-col]="currentFile() == null && !errors && minified != true"
                [class.cursor-pointer]="!isLocked() && !disabled" [class.cursor-not-allowed]="disabled"
                (click)="!disabled && triggerButtonClick()">
                <div class="flex items-center justify-center">
                    <bizz-icon class="ml-0 block sm:ml-auto md:ml-0" [ngClass]="[iconSizeClass, cursorClass]"
                        iconName="cloud-arrow-up" [hover]="!disabled">
                    </bizz-icon>
                </div>
                <div class="flex items-center justify-center">
                    <p [ngClass]="minified == true ? 'text-[10px]' : 'text-xs sm:text-sm'">{{
                        (minified == true ?
                        "Upload" : "DropOrUploadFile") | translate
                        }}</p>
                </div>
            </div>
            }
            @if ((currentFile() == null ||
            (field != null && field.ViewDataSourcesID != null && field.ViewDataSourcesID
            > 0 && !isInGrid())) && showStartFromTemplate() && !errors) {
            @if (!forceStartFromTemplate()) {
            <div class="flex sm:items-center sm:justify-center">
                <div class="h-0.5 h-full w-12 w-full rounded bg-divider-handle sm:w-1"
                    [class]="minified == true ? ['sm:h-8', 'my-1'] : ['sm:h-12', 'm-2.5']">
                </div>
            </div>
            }
            <div class="flex flex-1 items-center justify-center" [class.gap-4]="minified != true"
                [class.gap-0]="minified == true"
                [class.flex-col]="currentFile() == null && !errors &&  minified != true"
                [class.cursor-pointer]="!isLocked() && !disabled" [class.cursor-not-allowed]="disabled"
                (click)="!disabled && startFromTemplate()">
                <div class="flex items-center justify-center">
                    <bizz-icon class="ml-0 block  sm:ml-auto md:ml-0"
                        [ngClass]="minified == true ? 'size-5 text-blue-400' : currentFile() ? 'w-7 h-7 text-blue-500' : 'w-14 h-14 text-blue-500'"
                        iconName="memo" [hover]="true">
                    </bizz-icon>
                </div>
                <div class="flex items-center justify-center">
                    <p [ngClass]="minified == true ? 'text-[10px]' : 'text-xs sm:text-sm'">{{
                        (minified == true ?
                        "Template" : "StartFromTemplate") | translate
                        }}
                        <br>
                    </p>
                </div>
            </div>

            }
            @if (errors) {
            <div class="m-4 flex flex-1 items-center justify-center rounded text-red-500">
                <div class="flex flex-col items-center justify-center rounded text-red-500">
                    @if (errors.genericError) {
                    <p>{{ "SomethingWentWrong" | translate }}</p>
                    }
                    @if (errors.oversize) {
                    <p>{{ "Info_FileSizeExceeded" | translate }} {{
                        fileUploadService.formatFileSize(
                        errors.oversize.fileSize - errors.oversize.maxFileSize)
                        }}
                        , {{ "Info_MaximumFileSize" | translate }} {{
                        fileUploadService.formatFileSize(maxFileSize)
                        }}</p>
                    }
                    @if (errors.emptyFile) {
                    <p>{{ "Info_EmptyFile" | translate }}</p>
                    }
                    @if (errors.emptyExtension) {
                    <p>{{ "Info_EmptyExtension" | translate }}</p>
                    }
                    @if (errors.fileExtension) {
                    <p>{{ "Info_RequiredToUploadCsvFile" | translate }}</p>
                    }
                    @if (errors.fileNotAllowed) {
                    <p>{{ "ThisExtensionIsNotAllowed" | translate }}</p>
                    }
                    @if (errors.uploadError) {
                    <p>{{ "Info_UploadError" | translate }}</p>
                    }

                </div>
            </div>

            @if (!currentFile()) {
            @if (showStartFromTemplate()) {
            <div class="flex flex-1 items-center justify-center rounded text-red-500">
                <button type="button" class="button form text-xs" (click)="startFromTemplate()" [tabIndex]="-1"
                    [disabled]="isLocked()">
                    <bizz-icon class="ml-auto block size-3.5 text-blue-500 md:ml-0" iconName="memo" [hover]="true">
                    </bizz-icon>
                    {{ "StartFromTemplate" | translate }}
                </button>
            </div>
            }
            }
            }
        </div>
        }
        @if (currentFile() && field != undefined &&
        (field.ViewDataSourcesID == undefined || field.ViewDataSourcesID <= 0)) { <div
            class="flex w-full flex-wrap justify-center gap-3.5 px-4 pb-4 pt-2.5" [class.bg-section]="!errors">
            @if (showCheckOut()) {
            <button type="button" class="button form text-xs" [tabIndex]="-1" (click)="checkOut()"
                [disabled]="isLocked()">
                <bizz-icon class="ml-auto block size-3.5 text-blue-500 md:ml-0" iconName="file-pen" [hover]="true">
                </bizz-icon>
                {{ "CheckOut" | translate }}
            </button>
            }
            @if (showCheckIn()) {
            <button type="button" class="button form text-xs" [tabIndex]="-1" (click)="triggerButtonClick()"
                [disabled]="isLocked()">
                <bizz-icon class="ml-auto block size-3.5 text-blue-500 md:ml-0" iconName="file-pen" [hover]="true">
                </bizz-icon>
                {{ "CheckIn" | translate }}
            </button>
            }
            @if (showStartFromTemplate()) {
            <button type="button" class="button form text-xs" [tabIndex]="-1" (click)="startFromTemplate()"
                [disabled]="isLocked()">
                <bizz-icon class="ml-auto block size-3.5 text-blue-500 md:ml-0" iconName="memo" [hover]="true">
                </bizz-icon>
                {{ "StartFromTemplate" | translate }}
            </button>
            }
            @if (showEditOnline()) {
            <button type="button" class="button form text-xs" [tabIndex]="-1"
                (click)="openOnline(FileUploadEditOnlineModalComponentMode.Edit)">
                <bizz-icon class="ml-auto block size-3.5 text-blue-500 md:ml-0" iconName="pencil" [hover]="true">
                </bizz-icon>
                {{ "DirectEdit_Edit" | translate }}
            </button>
            }
            @if (showViewOnline()) {
            <button type="button" class="button form text-xs" [tabIndex]="-1"
                (click)="openOnline(FileUploadEditOnlineModalComponentMode.View)">
                <bizz-icon class="ml-auto block size-3.5 text-blue-500 md:ml-0" iconName="eye" [hover]="true">
                </bizz-icon>
                {{ "DirectEdit_View" | translate }}
            </button>
            }
            <button type="button" class="button delete rounded-md text-xs" [tabIndex]="-1" (click)="deleteFile()"
                [disabled]="isLocked()">
                <bizz-icon class="ml-auto block size-3.5 text-white md:ml-0" iconName="trash" [hover]="true">
                </bizz-icon>
                {{ "Delete" | translate }}
            </button>
    </div>
    }
    }
    </div>
    }
    }

    } @else {
    @if (currentFile(); as file) {
    @if (file.split('.').pop(); as ext) {
    @if (!isInGrid()) {
    <div class="flex cursor-pointer items-center justify-center gap-5 rounded border-2 border-section bg-section py-4 text-blue-500 hover:text-blue-700"
        (click)="downloadFromDataSource()">
        <bizz-extension-icon [extension]="ext" class="flex items-center">
        </bizz-extension-icon>
        <span class="text-small line-break-anywhere max-w-[calc(100%_-_40px)] text-wrap break-words font-semibold">{{
            file
            }}</span>
    </div>
    } @else {
    <div class="flex min-h-9 cursor-pointer items-center justify-center gap-4 text-blue-500 hover:text-blue-700"
        (click)="downloadFromDataSource()">
        <bizz-extension-icon [extension]="ext" [size]="'extraSmall'" class="flex items-center">
        </bizz-extension-icon>
        <span class="text-small line-break-anywhere max-w-[calc(100%_-_40px)] text-wrap break-words font-semibold">{{
            file
            }}</span>
    </div>
    }
    }
    } @else if (!isInGrid()) {
    <div class="flex items-center justify-center gap-5 rounded border-2 border-section bg-section py-4">
        <bizz-icon class="block w-6 text-widget-button" iconName="file-circle-exclamation" [hover]="true">
        </bizz-icon>
        <p class="text-sm text-widget-button">{{ "NoFile" | translate }}</p>
    </div>
    }

    }